module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "to-deponents"
  }, [_c('td', {
    staticClass: "date-container"
  }, [(!_vm.data.file) ? _c('span', {
    staticClass: "link",
    on: {
      "click": _vm.handleloadFile
    }
  }, [_vm._v("\n      Загрузить документ\n    ")]) : _c('span', [_c('span', {
    staticClass: "link"
  }, [_vm._v(_vm._s(_vm.data.file))]), _vm._v(" "), _c('span', {
    staticClass: "delete-document",
    on: {
      "click": function($event) {
        return _vm.deleteDeponentsDocumentFile(_vm.data.id)
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('input', {
    ref: "loadFile",
    attrs: {
      "type": "file",
      "id": "photo",
      "hidden": ""
    },
    on: {
      "change": _vm.loadFile
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "date-container"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false
    },
    on: {
      "change": _vm.dateChanged
    },
    model: {
      value: (_vm.publishDate),
      callback: function($$v) {
        _vm.publishDate = $$v
      },
      expression: "publishDate"
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "date-container"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false
    },
    on: {
      "change": _vm.dateChanged
    },
    model: {
      value: (_vm.eventDate),
      callback: function($$v) {
        _vm.eventDate = $$v
      },
      expression: "eventDate"
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "title-data"
  }, [_c('b-input', {
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.data.eventTitle),
      callback: function($$v) {
        _vm.$set(_vm.data, "eventTitle", $$v)
      },
      expression: "data.eventTitle"
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "emitents-data"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "",
      "filterable": ""
    },
    on: {
      "change": _vm.dataSelected
    },
    model: {
      value: (_vm.selectedData),
      callback: function($$v) {
        _vm.selectedData = $$v
      },
      expression: "selectedData"
    }
  }, _vm._l((_vm.emitentsData), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.value,
        "value": item.id
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(item.value))])])
  }), 1)], 1), _vm._v(" "), _c('td', {
    staticClass: "date-container"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false
    },
    on: {
      "change": _vm.dateChanged
    },
    model: {
      value: (_vm.registryClippingDate),
      callback: function($$v) {
        _vm.registryClippingDate = $$v
      },
      expression: "registryClippingDate"
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "date-container"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false
    },
    on: {
      "change": _vm.dateChanged
    },
    model: {
      value: (_vm.fixationDate),
      callback: function($$v) {
        _vm.fixationDate = $$v
      },
      expression: "fixationDate"
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "delete-cell"
  }, [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deleteDeponentsData(_vm.data.id)
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-414a0db9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Information/ToDeponentsItem.vue
// module id = 935
// module chunks = 0